import Vue from 'vue';

Vue.filter('date', function (date) {    
  try {
    return date.replaceAll('-', '/');
  } catch (err) {
    return date;
  }
});
